import React from "react";

const CarrotDown = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.27 6.11477L2.5 7.88477L12.5 17.8848L22.5 7.88476L20.73 6.11476L12.5 14.3448L4.27 6.11477Z"
        fill="#102337"
      />
    </svg>
  );
};

export default CarrotDown;
